import * as classnames from 'classnames/bind';
import * as React from 'react';
import {FontIcon} from "src/components/common/FontIcons";
import FIcon from "src/components/pages/home2/text/FIcon";

const styles = require('./Heading.module.less');
const cx = classnames.bind(styles) as any;

export enum Align
{
    Left     = 'left',
    Center   = 'center',
    Right    = 'right',
    Justify  = 'justify'
}

export enum Type
{
    Title    = 'title',
    Subtitle = 'subtitle',
}

interface Props
{
    title:string|JSX.Element;
    type?:Type;
    align?:Align;
    icon?:FontIcon;
    className?:string;
}

class State
{
}

export default class Heading extends React.Component<Props, State>
{
    constructor(props: Props)
    {
        super(props);
        this.state = new State();
    }

    render()
    {
        const {title, icon, className, align=Align.Left, type=Type.Title} = this.props;

        return  <div className={cx(className, 'heading', align, type)}>
                    {icon && <FIcon className={'icon'} name={icon as any}/>}
                    {title}
                </div>;
    }
}
